import { ReactNode, useState, createContext, useContext, useEffect } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { cn } from "@/lib/utils";
import LogoutConfirmDialog from "./LogoutConfirmDialog";

interface LayoutProps {
  children: ReactNode;
  className?: string;
  fullHeight?: boolean;
  withPadding?: boolean;
  isDarkTheme?: boolean;
}

// 创建全局对话框上下文
interface LogoutDialogContextType {
  showLogoutDialog: boolean;
  setShowLogoutDialog: (show: boolean) => void;
  openLogoutDialog: () => void;
}

export const LogoutDialogContext = createContext<LogoutDialogContextType>({
  showLogoutDialog: false,
  setShowLogoutDialog: () => {},
  openLogoutDialog: () => {},
});

// 创建全局hooks
export const useLogoutDialog = () => useContext(LogoutDialogContext);

const Layout = ({
  children,
  className,
  fullHeight = false,
  withPadding = true,
  isDarkTheme = true,
}: LayoutProps) => {
  const [showLogoutDialog, setShowLogoutDialog] = useState(false);
  const openLogoutDialog = () => setShowLogoutDialog(true);
  
  // 添加全局事件监听器来处理登出请求
  useEffect(() => {
    const handleLogoutEvent = () => {
      openLogoutDialog();
    };
    
    window.addEventListener('anzir-logout', handleLogoutEvent);
    
    return () => {
      window.removeEventListener('anzir-logout', handleLogoutEvent);
    };
  }, []);

  return (
    <LogoutDialogContext.Provider value={{ showLogoutDialog, setShowLogoutDialog, openLogoutDialog }}>
      <div className={cn(
        "min-h-screen flex flex-col",
        isDarkTheme 
          ? "bg-black" 
          : "bg-[#F6F6F7] text-[#333333]"
      )}>
        <Navbar isDarkTheme={isDarkTheme} />
        <main
          className={cn(
            "flex-grow",
            fullHeight && "flex flex-col",
            withPadding && "pt-24 pb-12",
            className
          )}
        >
          {children}
        </main>
        <Footer />
        
        {/* 全局退出确认对话框 */}
        <LogoutConfirmDialog 
          open={showLogoutDialog} 
          onOpenChange={setShowLogoutDialog} 
        />
      </div>
    </LogoutDialogContext.Provider>
  );
};

export default Layout;
